// extracted by mini-css-extract-plugin
export var chevronIcon = "_ai-2";
export var teamName = "_ai-1";
export var teamSwitcherButton = "_ai-0";